const AnnualAccount = {
  AnnualReport: "AnnualAccount.AnnualReport",
  SelectionHeaderText: "AnnualAccount.SelectionHeaderText",
  SelectionSubText: "AnnualAccount.SelectionSubText",
  AnnualReportAcceptSuccessMessage: "AnnualAccount.AnnualReportAcceptSuccessMessage",
  AnnualReportRejectSuccessMessage: "AnnualAccount.AnnualReportRejectSuccessMessage",
  AnnualReportCommentSuccessMessage: "AnnualAccount.AnnualReportCommentSuccessMessage",
  CommentDialogHeading: "AnnualAccount.CommentDialogHeading",
  CommentPlaceholder: "AnnualAccount.CommentPlaceholder",
  CommentDialogInfoText: "AnnualAccount.CommentDialogInfoText",
  ReviewAnnualReport: "AnnualAccount.ReviewAnnualReport",
  InformationAboutAnnualReport: "AnnualAccount.InformationAboutAnnualReport",
  Received: "AnnualAccount.Received",
  FinancialYear: "AnnualAccount.FinancialYear",
  FinancialStatementDescription: "AnnualAccount.FinancialStatementDescription",
  AnnualAccounts: "AnnualAccount.AnnualAccounts",
  SurveyTodoMainActionHeader: "AnnualAccount.SurveyTodoMainActionHeader",
  SurveyTodoMainActionDescription: "AnnualAccount.SurveyTodoMainActionDescription",
  ToApproveTodoMainActionHeader: "AnnualAccount.ToApproveTodoMainActionHeader",
  ToApproveTodoMainActionDescription: "AnnualAccount.ToApproveTodoMainActionDescription",
  ToApproveTodoMainActionHeaderHasEquity: "AnnualAccount.ToApproveTodoMainActionHeaderHasEquity",
  ToApproveTodoMainActionDescriptionHasEquity: "AnnualAccount.ToApproveTodoMainActionDescriptionHasEquity",
  ToApproveTodoMainActionBodyText: "AnnualAccount.ToApproveTodoMainActionBodyText",
  SelectDividend: "AnnualAccount.SelectDividend",
  NoDividendNoEquity: "AnnualAccount.NoDividendNoEquity",
  NoDividendAllowanceConsumed: "AnnualAccount.NoDividendAllowanceConsumed",
  WhatHappensAfterApproval: "AnnualAccount.WhatHappensAfterApproval",
  WhatHappensAfterApprovalBody: "AnnualAccount.WhatHappensAfterApprovalBody",
  AuditorReportUploadedSuccessMessage: "AnnualAccount.AuditorReportUploadedSuccessMessage",
  AuditorReportToUploadHeader: "AnnualAccount.AuditorReportToUploadHeader",
  AuditorReportToUploadSubHeader: "AnnualAccount.AuditorReportToUploadSubHeader",
  AnnualReportSigningStepsAtOneFlowHeader: "AnnualAccount.AnnualReportSigningStepsAtOneFlowHeader",
  AnnualReportSigningStepsHeaderXbrlSubmitted: "AnnualAccount.AnnualReportSigningStepsHeaderXbrlSubmitted",
  AnnualReportSignAtAnyProgram: "AnnualAccount.AnnualReportSignAtAnyProgram",
  AnnualReportSigningStepsBolagsverketDescription: "AnnualAccount.AnnualReportSigningStepsBolagsverketDescription",
  AnnualReportTimeLineStep1: "AnnualAccount.AnnualReportTimeLineStep1",
  AnnualReportTimeLineStep2: "AnnualAccount.AnnualReportTimeLineStep2",
  AnnualReportTimeLineStep3: "AnnualAccount.AnnualReportTimeLineStep3",
  AnnualReportAuditorReportStep: "AnnualAccount.AnnualReportAuditorReportStep",
  AnnualReportSigningStepsSubHeaderFirstState: "AnnualAccount.AnnualReportSigningStepsSubHeaderFirstState",
  AnnualReportSigningStepsSubHeaderSecondState: "AnnualAccount.AnnualReportSigningStepsSubHeaderSecondState",
  AnnualReportSigningStepsSubHeaderThirdState: "AnnualAccount.AnnualReportSigningStepsSubHeaderThirdState",
  AnnualReportAuditorSigningsSubHeaderFirstState: "AnnualAccount.AnnualReportAuditorSigningsSubHeaderFirstState",
  AnnualReportAuditorSigningsSubHeaderSecondState: "AnnualAccount.AnnualReportAuditorSigningsSubHeaderSecondState",
  AnnualReportAuditorSigningsSubHeaderThirdState: "AnnualAccount.AnnualReportAuditorSigningsSubHeaderThirdState",
  AnnualReportAuditorSigningsSubHeaderFourthState: "AnnualAccount.AnnualReportAuditorSigningsSubHeaderFourthState",
  AnnualReportAuditorSigningsSubHeaderFifthState: "AnnualAccount.AnnualReportAuditorSigningsSubHeaderFifthState",
  AnnualReportAuditorInfoMessage: "AnnualAccount.AnnualReportAuditorInfoMessage",
  AuditorReportToUploadDescription: "AnnualAccount.AuditorReportToUploadDescription",
  AuditorReportToUploadDescriptionHeader: "AnnualAccount.AuditorReportToUploadDescriptionHeader",
  AuditorReportUploadTooltip: "AnnualAccount.AuditorReportUploadTooltip",
  FinancialStatementsApprovalSigneeHeader: "AnnualAccount.FinancialStatementsApprovalSigneeHeader",
  FinancialStatementsApprovalSigneeDescription: "AnnualAccount.FinancialStatementsApprovalSigneeDescription",
  FinancialStatementsApprovalSigneePlaceholder: "AnnualAccount.FinancialStatementsApprovalSigneePlaceholder",
  FinancialStatementsApprovalSigneeTooltip: "AnnualAccount.FinancialStatementsApprovalSigneeTooltip",
  FinancialStatementsApprovalSigneeNoneAvailable: "AnnualAccount.FinancialStatementsApprovalSigneeNoneAvailable",
  FinancialStatementsApprovalSigneeLoadFailed: "AnnualAccount.FinancialStatementsApprovalSigneeLoadFailed",
  FinancialStatementsApprovalSigneeRetry: "AnnualAccount.FinancialStatementsApprovalSigneeRetry",
  AuditorReportToSignHeader: "AnnualAccount.AuditorReportToSignHeader",
  AuditorReportToSignSubHeader: "AnnualAccount.AuditorReportToSignSubHeader",
  AuditorReportToSignSuccessMessage: "AnnualAccount.AuditorReportToSignSuccessMessage",
  Dividend: "AnnualAccount.Dividend",
  DividendLabel: "AnnualAccount.DividendLabel",
  DividendSectionHeader: "AnnualAccount.DividendSectionHeader",
  DividendSectionSubHeader: "AnnualAccount.DividendSectionSubHeader",
  DividendSpace: "AnnualAccount.DividendSpace",
  OwnershipShare: "AnnualAccount.OwnershipShare",
  DividendTaxedAsSalary: "AnnualAccount.DividendTaxedAsSalary",
  DividendPerOwner: "AnnualAccount.DividendPerOwner",
  DividendSpaceWarning: "AnnualAccount.DividendSpaceWarning",
  NotManagedByWint: "AnnualAccount.NotManagedByWint",
  DividendUnknown: "AnnualAccount.DividendUnknown",
  LowTaxedDividend: "AnnualAccount.LowTaxedDividend",
  PossibleDividend: "AnnualAccount.PossibleDividend",
  NetEarnings: "AnnualAccount.NetEarnings",
  RetainedEarnings: "AnnualAccount.RetainedEarnings",
  SharePremiumFund: "AnnualAccount.SharePremiumFund",
  ChangeInEquity: "AnnualAccount.ChangeInEquity",
  NetEarningsToolTip: "AnnualAccount.NetEarningsToolTip",
  RetainedEarningsToolTip: "AnnualAccount.RetainedEarningsToolTip",
  SharePremiumFundToolTip: "AnnualAccount.SharePremiumFundToolTip",
  ChangeInEquityToolTip: "AnnualAccount.ChangeInEquityToolTip",
  PreliminaryYearResultWarning: "AnnualAccount.PreliminaryYearResultWarning",
  K10NotByWintWarning: "AnnualAccount.K10NotByWintWarning",
  K10NotByWintForAllShareholdersWarning: "AnnualAccount.K10NotByWintForAllShareholdersWarning",
  WintNotHandleK10Warning: "AnnualAccount.WintNotHandleK10Warning",
  ScheduledForWeek: "AnnualAccount.ScheduledForWeek",
  RepaymentOfShareholderContribution: "AnnualAccount.RepaymentOfShareholderContribution",
  RepaymentOfShareholderContributionToolTip: "AnnualAccount.RepaymentOfShareholderContributionToolTip",
  TheAnnualReport: "AnnualAccount.TheAnnualReport",
  TheAnnualGeneralMeetingMinutes: "AnnualAccount.TheAnnualGeneralMeetingMinutes",
  TheIncomeTaxReturn: "AnnualAccount.TheIncomeTaxReturn",
  AnnualFinancialStatement: "AnnualAccount.AnnualFinancialStatement",
  AnnualDocuments: "AnnualAccount.AnnualDocuments",
  AuditCompleteLabel: "AnnualAccount.AuditCompleteLabel",
  AuditCompleteDescription: "AnnualAccount.AuditCompleteDescription",
  ToApproveTodoMainActionHeaderIsRevisor: "AnnualAccount.ToApproveTodoMainActionHeaderIsRevisor",
  ToApproveTodoMainActionDescriptionIsRevisor: "AnnualAccount.ToApproveTodoMainActionDescriptionIsRevisor",
  ToApproveTodoHowTheSigningWorksTitle: "AnnualAccount.ToApproveTodoHowTheSigningWorksTitle",
  ToApproveTodoHowTheSigningWorksDescription: "AnnualAccount.ToApproveTodoHowTheSigningWorksDescription",
  ToApproveTodoBoardSignsAnnualReport: "AnnualAccount.ToApproveTodoBoardSignsAnnualReport",
  ToApproveTodoAuditorSignsAnnualReport: "AnnualAccount.ToApproveTodoAuditorSignsAnnualReport",
  ToApproveTodoSigningAuditorConfirmsAuditReportSigned: "AnnualAccount.ToApproveTodoSigningAuditorConfirmsAuditReportSigned",
  ToApproveTodoBoardSignsAnnualGeneralMeetingProtocol: "AnnualAccount.ToApproveTodoBoardSignsAnnualGeneralMeetingProtocol",
  ToApproveTodoBoardSignsSubmissionToBolagsverket: "AnnualAccount.ToApproveTodoBoardSignsSubmissionToBolagsverket",
  CustomerHasNotApprovedWarning: "AnnualAccount.CustomerHasNotApprovedWarning",
  K10OrderToggleLabelNone: "AnnualAccount.K10OrderToggleLabelNone",
  K10OrderToggleLabelPartial: "AnnualAccount.K10OrderToggleLabelPartial",
  K10OrderToggleSubText: "AnnualAccount.K10OrderToggleSubText",
  K10OrderDialogTitle: "AnnualAccount.K10OrderDialogTitle",
  K10OrderDialogIntro: "AnnualAccount.K10OrderDialogIntro",
  K10OrderInfoText: "AnnualAccount.K10OrderInfoText",
  K10OrderPriceLabel: "AnnualAccount.K10OrderPriceLabel",
  K10OrderPriceValue: "AnnualAccount.K10OrderPriceValue",
  K10OrderQuestionText: "AnnualAccount.K10OrderQuestionText",
  K10OrderCommentLabel: "AnnualAccount.K10OrderCommentLabel",
  K10OrderCommentHelpText: "AnnualAccount.K10OrderCommentHelpText",
  K10OrderButtonText: "AnnualAccount.K10OrderButtonText",
  K10OrderBackButton: "AnnualAccount.K10OrderBackButton",
  K10OrderSuccessMessage: "AnnualAccount.K10OrderSuccessMessage",
  K10OrderApproveButton: "AnnualAccount.K10OrderApproveButton",
  AnnualReportSignerSignedOn: "AnnualAccount.AnnualReportSignerSignedOn",
  AnnualReportSignerSigned: "AnnualAccount.AnnualReportSignerSigned",
  AnnualReportSignerWaiting: "AnnualAccount.AnnualReportSignerWaiting",
  AnnualReportSignersSignedCount: "AnnualAccount.AnnualReportSignersSignedCount",
  }
export default AnnualAccount;